export default __webpack_public_path__ + "Dispatch.a6f7821fa33d45c669a44aafe390d35d.svg";